// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Root from './Root'
import router from './router'
import Buefy from 'buefy'
//import 'buefy/dist/buefy.css'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import { messages } from './i18n'
import VueSocketIOExt from 'vue-socket.io-extended'
import { io } from 'socket.io-client'
import VueAnalytics from 'vue-analytics'
import store from './store'

Vue.use(Buefy)
Vue.use(Vuelidate)
Vue.use(VueI18n)

Vue.use(VueAnalytics, {
  id: 'UA-77635855-5',
  autoTracking: {
    exception: true
  }
})

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})

const socket = io(document.location.origin)
Vue.use(VueSocketIOExt, socket)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(Root),
  i18n
}).$mount('#app')
